import React, {useState} from "react";
import Agency from "./Agency";
import Index from "../Agents";
import UpdateAccount from "./updateAccount";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import TransactionStyles from "../Transactions/styles";
import ChangePassword from "./ChangePassword";
import {useSelector} from "react-redux";
const activeClass =
  "text-gray-600 py-4 px-6 block hover:text-blue-500 focus:outline-none text-blue-500 border-b-2 font-medium border-blue-500";
const inactiveClass =
  "text-gray-600 py-4 px-6 block hover:text-blue-500 focus:outline-none";
const Settings = () => {
  const user = useSelector((state) => state.auth?.user);
  const agentRole = user?.agent_role?.name;
  // const [tab, setTab] = useState(agentRole === "Super Agent"? "account" : "password");
  const [tab, setTab] = useState("password");

  return (
    <>
      <div className="content-layout intro-y mt-[5rem]">
        <div className="flex flex-col gap-8">
          <UpdateAccount />
          <ChangePassword />
        </div>
      </div>
    </>
  );
};

export default Settings;
